import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  INTEREST_POINT_FETCH_URI,
  INTEREST_POINT_FIND_URI
} from '@leapsight/styleguide'
import { GlobalHelpers } from '@/helpers/mainExports'

const COUNTRY_POSITION = {
  ar: { lat: -38.45155, lng: -63.5988853 },
  cl: { lat: -34.8688531, lng: -109.4392245 },
  uy: { lat: -32.5882583, lng: -58.4244884 }
}

const getPointOfInterest = id => {
  return new Promise((resolve, reject) => {
    const connection = store.getters['authState/connection']
    const security = connectionService.createkwArgs()
    const args = id
    const kwArgs = {
      ...security
      // query_spec: {
      //   _p: 'id, geometry, label, color, category, icon'
      // }
    }
    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      connection.session
        .call(INTEREST_POINT_FETCH_URI, [args], kwArgs, {})
        .then(response => {
          resolve(response.args[0])
        })
        .catch(error => {
          reject(error)
        })
    })
    Promise.race([p1, p2])
      .then(value => {
        resolve(value)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getPointsOfInterest = (
  { _p } = { _p: 'id, geometry, label, color, category, icon,description' }
) => {
  const connection = GlobalHelpers.getConnection()
  const security = connectionService.createkwArgs()
  const accountId = connectionService.getAccountId()
  const args = { account_id: accountId }
  const kwArgs = {
    ...security,
    query_spec: {
      _p
    }
  }
  const p1 = new Promise((resolve, reject) => {
    setTimeout(reject, RACE_TIMEOUT, [])
  })
  const p2 = new Promise((resolve, reject) => {
    connection.session
      .call(INTEREST_POINT_FIND_URI, [args], kwArgs, {})
      .then(response => {
        resolve(response.args[0])
      })
      .catch(error => {
        reject(error)
      })
  })
  return Promise.race([p1, p2])
    .then(value => {
      return value
    })
    .catch(error => {
      return error
    })
}

const pointsOnMap = (points, map, fitAndPanToBounds = false) => {
  const bounds = new google.maps.LatLngBounds()
  points.forEach(point => {
    if (!point.geometry.hasOwnProperty('coordinates')) return

    const lat = point.geometry.coordinates[0]
    const lng = point.geometry.coordinates[1]
    const position = new google.maps.LatLng(lat, lng)
    const iconUrl =
      point.icon && point.icon.includes('mdi')
        ? `https://cdn.jsdelivr.net/npm/@mdi/svg/svg/${point.icon.replace(
            'mdi-',
            ''
          )}.svg`
        : 'https://cdn.jsdelivr.net/npm/@mdi/svg/svg/star.svg'

    const pointOnMap = new google.maps.Marker({
      position,
      map,
      icon: {
        url: iconUrl,
        scaledSize: new google.maps.Size(26, 26),
        labelOrigin: new google.maps.Point(13, 35)
      },
      label: {
        text: point.label,
        color: point.color,
        fontSize: '14px'
      },
      visible: map.getZoom() >= 14
    })

    bounds.extend(position)
    map.addListener('zoom_changed', () => {
      const currentZoom = map.getZoom()
      pointOnMap.setVisible(currentZoom >= 14)
      const hasPoiSelectedLt = JSON.parse(
        localStorage.getItem('pointsOfInterestSelectedLt') ?? '[]'
      )
      if (
        currentZoom < 14 &&
        hasPoiSelectedLt.length &&
        store.getters['pointsOfInterestState/showPointsOfInterestOnMap']
      ) {
        store.dispatch('uiState/openSnackBar', {
          msg: 'Aumente el zoom en el mapa para ver los puntos de interés.',
          snackBarButtonClose: false
        })
      } else {
        store.dispatch('uiState/closeSnackBar')
      }
    })
    store.commit('pointsOfInterestState/addPointToMap', { pointOnMap })
  })
  if (!bounds.isEmpty() && fitAndPanToBounds) {
    map.fitBounds(bounds)
    map.panToBounds(bounds)
  }
}

const getGeometryType = item => {
  const type = item.geometry.type.toLowerCase()
  return type
}

export default {
  COUNTRY_POSITION,
  getPointOfInterest,
  getPointsOfInterest,
  pointsOnMap,
  getGeometryType
}
